export default __webpack_public_path__ + "static/media/03F4C4AC-FFA6-479C-8246-5C92D10A11C1.7a86e519.jpeg";